<footer class="page-footer pie-pagina">
      <div class="container">
            <div class="col-sm-12 text-left"><strong>Conoce más de SURA en:</strong></div>
            <div class="col-sm-12 text-left"><strong>www.sura.pe</strong></div>
      </div>
</footer>